const borders = {
    dash: "1px dashed",
    hairline: "1px solid",
    thin: "2px solid",
    light: "4px solid",
};

export default borders;
